/**
 * 单选题类型定义
 */

import { QuestionType } from '../../types';
import type { QuestionTypeMetadata } from '../types';

export const singleChoiceTypeMetadata: QuestionTypeMetadata = {
  type: QuestionType.SINGLE_CHOICE,
  name: '单选题',
  description: '只有一个正确答案的选择题',

  requiredFields: ['content', 'options', 'correctAnswer'],
  optionalFields: ['explanation', 'difficulty', 'tags', 'imageUrl', 'section', 'level'],

  fields: {
    content: {
      name: 'content',
      type: 'text',
      required: true,
      description: '题目内容',
    },
    options: {
      name: 'options',
      type: 'array',
      required: true,
      description: '选项列表',
      validator: (value) => {
        if (!Array.isArray(value) || value.length < 2) {
          return '选项至少需要2个';
        }
        const hasCorrect = value.some((opt: any) => opt.isCorrect === true);
        if (!hasCorrect) {
          return '至少需要一个正确答案';
        }
        return true;
      },
    },
    correctAnswer: {
      name: 'correctAnswer',
      type: 'string',
      required: true,
      description: '正确答案（选项ID）',
    },
    explanation: {
      name: 'explanation',
      type: 'text',
      required: false,
      description: '题目解析',
    },
    imageUrl: {
      name: 'imageUrl',
      type: 'url',
      required: false,
      description: '题目图片URL',
    },
  },

  validate: (question: any) => {
    const errors: any[] = [];

    // 验证必需字段
    if (!question.content || typeof question.content !== 'string') {
      errors.push({
        field: 'content',
        message: '题目内容不能为空',
        code: 'MISSING_CONTENT',
      });
    }

    if (!question.options || !Array.isArray(question.options) || question.options.length < 2) {
      errors.push({
        field: 'options',
        message: '至少需要2个选项',
        code: 'INVALID_OPTIONS',
      });
    }

    if (!question.correctAnswer || typeof question.correctAnswer !== 'string') {
      errors.push({
        field: 'correctAnswer',
        message: '正确答案必须是字符串',
        code: 'INVALID_ANSWER',
      });
    }

    // 验证正确答案是否在选项中
    if (question.options && question.correctAnswer) {
      const optionIds = question.options.map((opt: any) => opt.id);
      if (!optionIds.includes(question.correctAnswer)) {
        errors.push({
          field: 'correctAnswer',
          message: '正确答案必须在选项列表中',
          code: 'ANSWER_NOT_IN_OPTIONS',
        });
      }
    }

    return {
      valid: errors.length === 0,
      errors,
    };
  },

  renderConfig: {
    layout: 'default',
    showFields: ['content', 'imageUrl', 'options'],
  },
};
